
import ExerciseTask from "#infra/task/ExerciseTask";
import ExerciseTestAbs from "#infra/test/ExerciseTestAbs";
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import ExerciseMap, { ExerciseItem } from "../../exercises/ExerciseMap";
import CodeEditor from './CodeEditor';
import DialogButton from "./DialogButton";
import DiffCodeEditor from './DiffCodeEditor';

export default function SolutionButton(props: any) {
  const params = useParams();
  const { currentSolutionText, buttonText, correctMsg, incorrectMsg } = props;
  const courseName: string = params.courseName || "";
  const chapterName: string = params.chapterName || "";
  const lessonName: string = params.lessonName || "";
  const exerciseName: string = params.exerciseName || "";
  const taskIdStr: string = params.taskId || "";
  const showComparison = currentSolutionText !== undefined;

  if (!exerciseName) {
    console.error("missing exerciseName");
    return <div>Missing exerciseName</div>;
  }
  if (!taskIdStr) {
    console.error("missing taskId");
    return <div>Missing taskId</div>;
  }
  const taskId: number = Number(taskIdStr);

  const exerciseMap = new ExerciseMap();
  const exerciseItem: ExerciseItem | null = exerciseMap.getExerciseItem(courseName, chapterName,
    lessonName, exerciseName);
  if (!exerciseItem) {
    return <Box mx={2} className="app">No exercise found</Box>;
  }

  const exerciseTask: ExerciseTask =
    exerciseItem.exerciseMgr.getTask(taskId);
  const exerciseTest: ExerciseTestAbs = exerciseTask.getTest();
  const expectedSolutionText = exerciseTest.getExpectedSolutionText();
  const isCorrectSolution = currentSolutionText === expectedSolutionText;

  const handleClose = () => {
  }

  return (
    <DialogButton dialogTitle="Solution"
      dialogProps={{ maxWidth: "xl" }}
      buttonText={buttonText}
      buttonProps={{
        size: "small",
        variant: "contained",
        color: "primary",
        disabled: props.disabled,
      }}
      onClose={handleClose}
    >
      {currentSolutionText !== undefined &&
        <Box sx={{ mb: 1, flex: 1 }}>
          {isCorrectSolution ?
            <Typography variant="subtitle1" color="green">{correctMsg}</Typography> :
            <Typography variant="subtitle1" color="red">{incorrectMsg}</Typography>
          }
        </Box>
      }
      <Box sx={{ mb: 1, display: "flex", flexDirection: "row" }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold">Expected Solution</Typography>
        </Box>
        {showComparison &&
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" fontWeight="bold">My Solution</Typography>
          </Box>
        }
      </Box>

      <Box sx={{
        mb: 2,
        height: "300px",
        border: "1px solid black",
        borderRadius: "4px",
      }}>
        {!showComparison &&
          <CodeEditor value={expectedSolutionText}
            path="current-code.ts"
            readOnly
          />
        }
        {showComparison &&
          <DiffCodeEditor original={expectedSolutionText}
            modified={currentSolutionText}
          />
        }
      </Box>
    </DialogButton>
  );
}
